<template>
  <div id="homeInfo">
    <div class="colspan">
      <div class="information clearfix">
        <div class="information-left clearfix">
          <div class="information-left-header clearfix">
            <i></i>
            <p class="p1 clearfix">
              <img :src="discoveryImg" align="center" />
              <span>{{recommendData3.title}}</span>
            </p>
            <p @click="gotoDocument(recommendData3.channel_id)" class="p2 clearfix">更多></p>
          </div>
          <div class="information-left-main clearfix">
            <div
              v-for="(item,index) in recommendData3.new_data "
              v-if="index<2"
              :key="index"
              @click="goto(item.id,recommendData3.template,recommendData3.channel_id,2)"
            >
              <div class="imgs">
                <img v-if="item.cover_photo_text" v-lazy="item.cover_photo_text.url" alt />
              </div>

              <p
                :title="item[getTemplate(recommendData3.template).title]"
              >{{item[getTemplate(recommendData3.template).title]}}</p>
              <router-link to>详情</router-link>
            </div>
          </div>
          <div class="information-left-bottom clearfix">
            <i></i>
            <div class="left">
              <ul>
                <li
                  @click="goto(item.id,recommendData3.template,recommendData3.channel_id,2)"
                  v-for="(item,index) in recommendData3.new_data "
                  v-if="index>=2"
                  :key="index"
                >
                  <span>{{recommendData3.title}}</span>
                  <p
                    :title="item[getTemplate(recommendData3.template).title]"
                  >{{item[getTemplate(recommendData3.template).title]}}</p>
                  <div v-if="item.if_new==1" class="icon">new</div>
                </li>
              </ul>
            </div>
            <div class="right">
              <div>
                <div
                  class="content"
                  @click="goto(item.id,item.template,item.value.channel_id,1)"
                  v-for="(item,index)  in recommendData4 "
                  :key="index"
                >
                  <div>
                    <img :src="compileImg" alt v-if="item.index==4" />
                    <img :src="inviteImg" alt v-if="item.index==5" />
                    <img :src="disposeImg" alt v-if="item.index==6" />
                    <img :src="tagetImg" alt v-if="item.index==7" />
                  </div>
                  <span>{{item.title}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="love">
          <div class="title">爱心捐赠</div>
          <div class="love_bottom">
            <div class="amount clearfix">
              <div>捐赠总额</div>
              <div>{{amount}}</div>
              <div>元</div>
            </div>
            <div class="count clearfix">
              <div>捐赠人次</div>
              <div>{{count}}</div>
              <div>人次</div>
            </div>
          </div>
        </div>
        <div class="information-right">
          <i></i>
          <div class="information-right-header clearfix">
            <i></i>
            <p class="p1 clearfix">
              <img :src="loveImg" align="center" />
              <span>爱心捐赠</span>
            </p>
            <div class="more" @click="gotoMore(tempList4[9].value.channel_id)">更多></div>
          </div>
          <div class="information-right-bottom clearfix">
            <div class="main">
              <vue-seamless-scroll :data="donationList" class="seamless-warp">
                <ul id="ul">
                  <li v-for="(item) in donationList" :key="item.id">
                    <i></i>
                    <p>{{item.pub_name||item.name}}</p>
                    <span>￥{{item.money}}</span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import "../../assets/fonts/font.less";

export default {
  props: {
    tempList3: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tempList4: {
      type: Array,

      default: function() {
        return [];
      }
    },
    donationList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      recommendData4: [],
      channelData: [],
      recommendData3: {},
      infoList: [],
      currentList: [],
      style: "shaodong",
      discoveryImg: require("../../assets/images/shaodong/icon_discovery.png"),
      disposeImg: require("../../assets/images/shaodong/icon_dispose.png"),
      compileImg: require("../../assets/images/shaodong/icon_compile.png"),
      inviteImg: require("../../assets/images/shaodong/icon_invite.png"),
      tagetImg: require("../../assets/images/shaodong/icon_little_taget.png"),
      donationImg: require("../../assets/images/shaodong/donation.png"),
      loveImg: require("../../assets/images/shaodong/love.png"),
      amount: "",
      count: ""
    };
  },
  methods: {
    gotoMore(id) {
      if (id) {
        this.$db
          .get(this.$url.channel.url + "/" + id)
          .then(resp => {
            let data = resp.data;
            this.channelGoto(data);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    goto(id, template, channel_id, type = 1) {
      channel_id = Number(channel_id);
      this.$db
        .get(this.$url.channel.url + "/" + channel_id)
        .then(res => {
          if (type == 1) {
            let path_params = {};
            path_params = this.getTemplate(res.data.template);
            if (res.data.pid == 0) {
              this.$router.push({
                path: path_params.path,
                query: { id: res.data.id }
              });
            } else {
              this.$router.push({
                path: path_params.path,
                query: { id: res.data.pid, second_navId: res.data.id }
              });
            }
          } else {
            if (res.data.pid == 0) {
              if (template == 1 || template == 2) {
                this.$router.push({
                  name: "projectDetail",
                  query: { projectInfoId: id, id: channel_id }
                });
              } else if (template == 3 || template == 4) {
                this.$router.push({
                  name: "details",
                  query: { newsId: id, id: channel_id }
                });
              }
            } else {
              if (template == 1 || template == 2) {
                this.$router.push({
                  name: "projectDetail",
                  query: {
                    projectInfoId: id,
                    id: res.data.pid,
                    second_navId: res.data.id
                  }
                });
              } else if (template == 3 || template == 4) {
                this.$router.push({
                  name: "details",
                  query: {
                    id: res.data.pid,
                    newsId: id,
                    second_navId: res.data.id
                  }
                });
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    gotoDocument(value) {
      this.$db
        .get(this.$url.channel.url + "/" + value)
        .then(res => {
          let path_params = {};
          path_params = this.getTemplate(res.data.template);
          let param = "";
          if (res.data.pid == 0) {
            this.$router.push({
              path: path_params.path,
              query: { id: res.data.id }
            });
          } else {
            this.$router.push({
              path: path_params.path,
              query: { id: res.data.pid, second_navId: res.data.id }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getListData(id, limit, index) {
      if (id) {
        let params = {};
        params.id_arr = id;
        params.template_data_page_size = limit;
        params.if_recommend = 1;
        this.$db
          .get(this.$url.channel.list, params)
          .then(resp => {
            if (resp.code == 200) {
              let arr = {};
              if (resp.data && resp.data[0]) {
                let data = resp.data[0];
                arr.title = data.title ? data.title : "";
                arr.channel_id = data.channel_id;
                arr.template = data.template;
                arr.new_data = data.template_data_list.data;
              }

              if (index == 3) {
                this.recommendData3 = arr;
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    getNameByChannelId(channelData, id) {
      let value = {};
      channelData.forEach((item, index) => {
        if (item.id == id) {
          value = item;
        }
      });
      return value;
    },
    //数字格式化(每三位加逗号)
    toThousands(num) {
      var num = (num || 0).toString(),
        result = "";
      while (num.length > 3) {
        result = "," + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      return result;
    },
    ...mapActions(["getWebconfigInfo"])
  },
  created() {
    this.$db
      .get(this.$url.channel.list)
      .then(resp => {
        let data = resp.data;
        this.channelData = data;
      })
      .then(() => {
        if (this.tempList4 && this.tempList4.length > 0) {
          this.tempList4.forEach((item, index) => {
            if ([4, 5, 6, 7].indexOf(item.index) > -1) {
              let param = this.getNameByChannelId(
                this.channelData,
                item.value.channel_id
              );
              item.title = param.title;
              item.template = param.template;
              this.recommendData4.push(item);
            }
          });
        }
      })
      .catch(err => {
        console.log(err);
      });

    // if( JSON.stringify(this.tempList3) !== '{}' ){

    //     this.getListData(this.tempList3.value.channel_id,this.tempList3.value.limit,this.tempList3.index)
    // }
    this.getWebconfigInfo()
      .then(res => {
        this.style = res.style ? res.style : "";
        if (this.style) {
          this.discoveryImg = require("../../assets/images/" +
            this.style +
            "/icon_discovery.png");
          this.disposeImg = require("../../assets/images/" +
            this.style +
            "/icon_dispose.png");
          this.compileImg = require("../../assets/images/" +
            this.style +
            "/icon_compile.png");
          this.inviteImg = require("../../assets/images/" +
            this.style +
            "/icon_invite.png");
          this.tagetImg = require("../../assets/images/" +
            this.style +
            "/icon_little_taget.png");
          this.donationImg = require("../../assets/images/" +
            this.style +
            "/donation.png");
          this.loveImg = require("../../assets/images/" +
            this.style +
            "/love.png");
        }
      })
      .catch(err => {
        console.log(err);
      });
    this.$db
      .get(this.$url.donation.index)
      .then(res => {
        if (res.code == 200) {
          this.amount = this.toThousands(Math.round(res.data.donation_sum));
          this.count = this.toThousands(res.data.donation_count);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  watch: {
    tempList3: function(value) {
      this.tempList3 = value;
      if (this.tempList3 && this.tempList3.value) {
        this.getListData(
          this.tempList3.value.channel_id,
          this.tempList3.value.limit,
          this.tempList3.index
        );
      }
    },
    tempList4: function(value) {
      this.tempList4 = value;
    }
  }
};
</script>
<style lang="less" scoped>
.colspan {
  margin: 0 auto;
  width: 1200px;
}
.lubotu {
  width: 100%;
}
.information {
  margin-top: 20px;
  min-height: 450px;
  width: 100%;
  background-color: #fff;
  position: relative;
  > .information-left {
    float: left;
    min-height: 470px;
    width: 810px;
    border: solid 1px #e5e5e5;
    box-sizing: border-box;
    padding: 0 16px;
    > .information-left-header {
      > i {
        width: 104px;
        height: 2px;
        position: absolute;
        left: 16px;
        top: 0;
      }
      > .p1 {
        float: left;
        font-size: 20px;
        font-weight: 700;
        font-family: MicrosoftYaHei-Bold;
      }
      > .p2 {
        float: right;
        color: #ccc;
        font-size: 14px;
        cursor: pointer;
      }
    }
    > .information-left-main {
      display: flex;
      justify-content: space-between;
      min-height: 152px;
      > div {
        cursor: pointer;
        float: left;
        margin-right: 56px;
        overflow: hidden;
        position: relative;
        > .imgs {
          float: left;
          width: 206px;
          height: 130px;
          overflow: hidden;
          margin: 0 14px;
          background-color: #f4f4f4;
          > img {
            width: 100%;
            transition: all 0.6s;
          }
          > img:hover {
            transform: scale(1.2);
          }
        }
        > p {
          font-family: "微软雅黑";
          color: #404040;
          margin: 0;
          line-height: 24px;
          width: 90px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          font-size: 16px;
        }
        > p:hover {
          text-decoration: underline;
        }
        > a {
          position: absolute;
          text-decoration: none;
          font-size: 14px;
          bottom: 0;
        }
      }
      > div:nth-of-type(3) {
        margin-right: 0;
      }
    }
    > .information-left-bottom {
      position: relative;
      margin-top: 13px;
      min-height: 100px;
      width: 100%;
      > i {
        width: 100%;
        height: 1px;
        background-color: #ccc;
        position: absolute;
        left: 0;
        top: 0;
      }
      > .left {
        width: 62%;
        height: 220px;
        float: left;
        ul {
          list-style-type: none;
          padding-left: 0;
          margin: 0;
          margin-top: 24px;
          height: 100%;
          overflow: hidden;
        }
        ul li {
          padding: 5px 0;
          font-size: 16px;
          color: #404040;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          > span {
            float: left;
            color: #888;
            font-size: 16px;
          }
          > span::after {
            content: "|";
            height: 5px;
            width: 1px;
            color: #e5e5e5;
            padding: 5px;
          }
          > p {
            margin: 0;
            float: left;
            width: 350px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            cursor: pointer;
          }
          .icon {
            width: 38px;
            height: 18px;
            line-height: 18px;
            border: 1px solid #ea373b;
            font-weight: normal;
            font-size: 14px;
            text-align: center;
            border-radius: 3px;
            color: #ea373b;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
          }
        }
      }
      > .right {
        > div {
          > .content {
            cursor: pointer;
            float: left;
            width: 120px;
            height: 105px;
            border-radius: 4px;
            box-sizing: border-box;
            margin-left: 2px;
            > div {
              cursor: pointer;
              width: 50px;
              height: 50px;
              background-color: #fff;
              border-radius: 50%;
              text-align: center;
              margin-left: 35px;
              margin-top: 10px;
            }
            img {
              width: 50%;
              padding: 25%;
              transition: all 1s;
            }
            img:hover {
              transform: scale(1.2);
            }
            > span {
              display: inline-block;
              color: #fff;
              width: 100%;
              text-align: center;
              margin-top: 5px;
            }
          }
          .content:nth-of-type(1),
          .content:nth-of-type(2) {
            margin-top: 12px;
            margin-bottom: 2px;
          }
          .content:nth-of-type(1),
          .content:nth-of-type(3) {
            margin-left: 50px;
          }
        }
      }
    }
  }
  > .love {
    float: left;
    width: 370px;
    height: 140px;
    margin-left: 20px;
    margin-bottom: 20px;
    .title {
      margin: 16px 0 20px;
      color: #fff;
      font-size: 18px;
      text-align: center;
      font-weight: 550;
      font-family: myFont;
    }
    .love_bottom {
      color: #fff;
      padding: 0 30px;
      .amount,
      .count {
        margin-bottom: 20px;
        font-family: myFont;
        div:nth-of-type(1) {
          float: left;
        }
        div:nth-of-type(2) {
          width: 214px;
          font-size: 20px;
          line-height: 14px;
          font-family: myFont;
          display: inline-block;
          text-align: center;
        }
        div:nth-of-type(3){
            float: right;
        }
      }
    }
  }
  > .information-right {
    float: left;
    margin-left: 20px;
    height: 310px;
    width: calc(100% - 830px);
    box-sizing: border-box;
    border: solid 1px #e5e5e5;
    padding: 0 16px;
    position: relative;
    overflow: hidden;
    > i {
      width: 100%;
      height: 1px;
      background-color: #ccc;
      position: absolute;
      left: 0;
      top: 50px;
    }
    > .information-right-header {
      position: relative;
      z-index: 9999;
      height: 50px;
      > i {
        width: 110px;
        height: 2px;
        position: absolute;
        left: 0;
        top: 0;
      }
      > .p1 {
        float: left;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        margin: 0;
        font-weight: 700;
        line-height: 50px;
      }
      > .p2 {
        float: right;
        color: #ccc;
        cursor: pointer;
        font-size: 14px;
        margin: 0;
        line-height: 50px;
      }
      .more {
        cursor: pointer;
        color: #888;
        font-size: 14px;
        height: 50px;
        line-height: 50px;
        float: right;
      }
    }
    > .information-right-bottom {
      width: 100%;
      overflow: hidden;
      > .main {
        width: 100%;
        height: 100%;
        float: left;
        overflow: hidden;
        > .seamless-warp {
          height: 100%;
          overflow: hidden;
        }
        ul {
          width: 100%;
          height: 200%;
          list-style-type: none;
          padding-left: 0;
          margin: 0;
          overflow: hidden;
        }
        ul li {
          font-size: 16px;
          color: #404040;
          // overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          height: 38px;
          line-height: 38px;
          box-sizing: border-box;
          > i {
            width: 100%;
            height: 1px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            bottom: 1px;
          }

          > p {
            float: left;
            margin: 0;
            color: #404040;
          }
          > span {
            float: right;
            font-size: 14px;
          }
        }
      }
    }
  }
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ".";
  clear: both;
  height: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/info.vue